{
  "editDialog": {
    "titleNew": "Նոր աշխատակից",
    "titleEdit": "Խմբագրել աշխատակիցը — PIN {{pin}}",
    "pinLabel": "Սարքի օգտ. ID (PIN)",
    "nameLabel": "Անուն Ազգանուն",
    "roleLabel": "Դեր",
    "cardLabel": "Քարտի համար",
    "payRates": {
      "legend": "Դրույքաչափեր (AMD)",
      "hourlyRate": "Ժամային դրույք (AMD/ժ)",
      "monthlySalary": "Ամսական աշխատավարձ (AMD)",
      "afterHoursRate": "Արտաժամյա դրույք (AMD/ժ)",
      "explainer": "Ժամային դրույքն օգտագործվում է ժամաքանակի հիման վրա վճարման դեպքում: Ամսական աշխատավարձը բաշխվում է համամասնորեն աշխատանքային օրերի վրա: Արտաժամյա դրույքը կիրառվում է հիմնական աշխատաժամերից դուրս ժամերի համար:",
      "unitPerHour": "AMD/ժ",
      "unitMonthly": "AMD"
    },
    "workHours": {
      "legend": "Աշխատանքային ժամեր",
      "startLabel": "Օրվա սկիզբ",
      "endLabel": "Օրվա ավարտ",
      "explainer": "Աշխատակցի աշխատանքային օրվա սկիզբն ու ավարտը (ըստ ցանկության)։ Թողեք դատարկ՝ ընկերության ընդհանուր գրաֆիկն օգտագործելու համար։ Փոփոխված ժամերը գործում են այսօրվանից, եթե ամսաթիվ նշված չէ. անցած օրերը հաշվարկվում են նախկին գրաֆիկով:",
      "attendanceExemptLabel": "Լռելյայն ներկա (ազատ գրաֆիկ)",
      "attendanceExemptHint": "Ուշացման, վաղ հեռանալու, բացակայության պահումներ և արտաժամյա հաշվարկ չեն կիրառվում. տաբելում աշխատանքային օրերը նշվում են որպես ներկա՝ նույնիսկ առանց տերմինալի նշումների:",
      "effectiveFromLabel": "Գործում է սկսած",
      "daysPerWeekLabel": "Աշխատանքային օրեր շաբաթում",
      "daysPerWeekCompany": "Ըստ ընկերության գրաֆիկի",
      "daysPerWeekHint": "Օրինակ՝ 6, երբ աշխատակիցն ունի շաբաթական մեկ լողացող հանգստյան օր. այն ինքնաբերաբար կհաշվառվի:",
      "restWeekdaysLabel": "Անհատական հանգստյան օրեր",
      "restWeekdaysHint": "Տվյալ աշխատակցի մշտական հանգստյան օրերը։ Ընտրված օրերը տաբելում նշվում են X-ով, պահում չի կիրառվում, և դրանք դուրս են մնում աշխատավարձի բաժանարարից։ Ոչինչ չընտրելու դեպքում գործում է ընկերության գրաֆիկը:",
      "days": {
        "mon": "Երկ",
        "tue": "Երք",
        "wed": "Չրք",
        "thu": "Հնգ",
        "fri": "Ուր",
        "sat": "Շբթ",
        "sun": "Կիր"
      }
    },
    "dates": {
      "legend": "Ընդունելության և ազատման ամսաթվեր",
      "hiredLabel": "Առաջին աշխատանքային օր",
      "registeredLabel": "Գրանցման ամսաթիվ",
      "terminatedLabel": "Ազատման ամսաթիվ",
      "explainer": "Այս ամսաթվերը ցուցադրվում են «Ընդունելություն» հաշվետվությունում՝ ընդունելության սկիզբ, գրանցման սկիզբ և ավարտ։"
    },
    "vacation": {
      "legend": "Արձակուրդ",
      "carryoverLabel": "Նախորդ տարիներից փոխանցված օրեր",
      "explainer": "Մինչև ընթացիկ տարին չօգտագործված արձակուրդի օրերը (օրինակ՝ հին Excel աղյուսակից)։ Արձակուրդների աղյուսակում գումարվում են տարեկան 20 օր սահմանաչափին։ Թույլատրվում են կոտորակային և բացասական արժեքներ։"
    },
    "activeLabel": "Ակտիվ",
    "saveFailed": "Չհաջողվեց պահպանել",
    "pushNotice": "Պահպանելուց հետո տերմինալին կուղարկվի հրաման:",
    "autoSyncNotice": "Փոփոխությունները ավտոմատ կուղարկվեն տերմինալ:",
    "contact": {
      "legend": "Անձնական տվյալներ և կապ",
      "birthDateLabel": "Ծննդյան օր",
      "phoneLabel": "Հեռախոս",
      "emailLabel": "Էլ. հասցե"
    }
  },
  "entriesExits": {
    "title": "Մուտքեր/Ելքեր",
    "exportCsv": "Արտահանել CSV",
    "failedToLoad": "Չհաջողվեց բեռնել տվյալները: Խնդրում ենք թարմացնել էջը:",
    "noRecords": "Ընտրված ժամանակաշրջանի համար գրառումներ չկան",
    "noRecordsHint": "Ճշգրտեք ֆիլտրերը կամ սպասեք սարքի տվյալների համաժամացմանը",
    "filters": {
      "type": "Տեսակ",
      "allTypes": "— բոլորը —"
    },
    "eventTypes": {
      "entry": "Մուտք",
      "exit": "Ելք",
      "breakOut": "Ընդմիջման սկիզբ",
      "breakReturn": "Ընդմիջման ավարտ",
      "overtimeIn": "Արտաժամի սկիզբ",
      "overtimeOut": "Արտաժամի ավարտ"
    },
    "verifyModes": {
      "password": "Գաղտնաբառ",
      "fingerprint": "Մատնահետք",
      "card": "Քարտ",
      "passwordFingerprint": "Գաղտնաբառ + մատնահետք",
      "passwordCard": "Գաղտնաբառ + քարտ",
      "face": "Դեմք",
      "modeN": "Ռեժիմ {{n}}"
    },
    "columns": {
      "timestamp": "Ժամանակ",
      "employee": "Աշխատակից",
      "type": "Տեսակ",
      "verifyMethod": "Ստուգման եղանակ"
    },
    "manual": {
      "addButton": "Ավելացնել նշում",
      "title": "Ձեռքով նշում",
      "subtitle": "Երբ աշխատակիցը մոռացել է նշվել տերմինալում։",
      "employeeLabel": "Աշխատակից",
      "employeePlaceholder": "Ընտրեք աշխատակցին…",
      "dateLabel": "Ամսաթիվ",
      "timeLabel": "Ժամ",
      "noteLabel": "Նշում (ոչ պարտադիր)",
      "notePlaceholder": "օր.՝ մոռացել է նշվել գալիս",
      "badge": "Ձեռքով",
      "confirmDelete": "Ջնջե՞լ {{name}}-ի այս գրառումը։",
      "errors": {
        "employeeRequired": "Ընտրեք աշխատակցին։",
        "dateRequired": "Ընտրեք ամսաթիվը։",
        "timeRequired": "Նշեք ժամը։"
      },
      "toasts": {
        "created": "Գրառումն ավելացվել է։",
        "createFailed": "Չհաջողվեց ավելացնել գրառումը։",
        "duplicate": "Այս աշխատակցի համար այդ ժամին արդեն կա գրառում։",
        "deleted": "Գրառումը ջնջվել է։",
        "deleteFailed": "Չհաջողվեց ջնջել գրառումը։"
      }
    }
  },
  "profile": {
    "back": "Աշխատակիցներ",
    "failedToLoad": "Չհաջողվեց բեռնել աշխատակցի տվյալները։",
    "fields": {
      "birthDate": "Ծննդյան օր",
      "phone": "Հեռախոս",
      "email": "Էլ. հասցե"
    },
    "documents": {
      "title": "Փաստաթղթեր",
      "hint": "Անձնագրի պատճեններ, պայմանագրեր և այլ ֆայլեր։ PDF, նկարներ, Word/Excel՝ մինչև 15 ՄԲ։",
      "upload": "Բեռնել փաստաթուղթ",
      "uploading": "Բեռնվում է…",
      "empty": "Փաստաթղթեր դեռ չկան։",
      "downloadAria": "Ներբեռնել փաստաթուղթը",
      "deleteAria": "Ջնջել փաստաթուղթը",
      "toasts": {
        "uploaded": "Փաստաթուղթը բեռնվել է։",
        "uploadFailed": "Չհաջողվեց բեռնել փաստաթուղթը։ Կրկին փորձեք։",
        "deleted": "Փաստաթուղթը ջնջվել է։",
        "deleteFailed": "Չհաջողվեց ջնջել փաստաթուղթը։ Կրկին փորձեք։",
        "downloadFailed": "Չհաջողվեց ներբեռնել փաստաթուղթը։ Կրկին փորձեք։"
      }
    },
    "details": {
      "title": "Մանրամասներ",
      "work": "Աշխատանք և ամսաթվեր",
      "workHours": "Աշխատանքային ժամեր",
      "companySchedule": "Ընկերության գրաֆիկ",
      "terminals": "Տերմինալներ և կենսաչափություն",
      "devices": "Տերմինալներ",
      "biometrics": "Կենսաչափություն",
      "pay": "Վարձատրություն",
      "hourlyRate": "Ժամային դրույք",
      "monthlySalary": "Ամսական աշխատավարձ",
      "overtimeRate": "Արտաժամյա դրույք",
      "carryover": "Արձակուրդի փոխանցում",
      "daysUnit": "օր",
      "biometricKinds": {
        "face": "Դեմք",
        "fp": "Մատնահետք",
        "palm": "Ափ"
      }
    },
    "photo": {
      "changeAria": "Փոխել լուսանկարը",
      "removeAria": "Հեռացնել լուսանկարը",
      "hint": "JPEG, PNG կամ WebP — մինչև 10 ՄԲ:",
      "toasts": {
        "uploaded": "Լուսանկարը թարմացվեց:",
        "uploadFailed": "Չհաջողվեց վերբեռնել լուսանկարը։ Փորձեք կրկին:",
        "removed": "Լուսանկարը հեռացվեց:",
        "removeFailed": "Չհաջողվեց հեռացնել լուսանկարը։ Փորձեք կրկին:"
      }
    }
  }
}
